import { render, staticRenderFns } from "./HorizontalNav.vue?vue&type=template&id=5d3389d2&"
import script from "./HorizontalNav.vue?vue&type=script&lang=js&"
export * from "./HorizontalNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports